import { useMemo } from "react";
import { useAuth } from "react-oidc-context";
import { jwtDecode } from "jwt-decode";
import { useActiveOrg } from "common-fe";
import { hasAssignScribesPermission } from "../permissions";

// Does the signed-in user hold score:assign_scribes in the active org? The
// permission the class-setting routes (paper entry, Placed by division, ...)
// require. Reads the access token's `roles` claim directly rather than
// common-fe's usePermission(), for the reason apps/scoreadmin-fe/src/
// permissions.js explains. Fails closed: no token, no active org or an
// undecodable token all read as false.
//
// Extracted from ClassDetailDrawer (#2415) so ClassManager can gate the bulk
// dialog's Placed by division field (#3405) on the same check.
export function useCanAssignScribes() {
  const auth = useAuth();
  const { activeOrgId, isSuper } = useActiveOrg();
  const accessToken = auth.user?.access_token;
  return useMemo(() => {
    if (!accessToken) return false;
    // #3414: a super admin holds every capability in every org.
    if (isSuper === true) return true;
    if (!activeOrgId) return false;
    try {
      const claims = jwtDecode(accessToken);
      const raw = claims.roles;
      const map = typeof raw === "string" ? JSON.parse(raw) : raw || {};
      return hasAssignScribesPermission(map[activeOrgId], isSuper);
    } catch {
      return false;
    }
  }, [accessToken, activeOrgId, isSuper]);
}

export default useCanAssignScribes;
